'use client';

import { routesWithoutDrawer } from '@/app/routes';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';

const usePageDrawer = () => {
  const pathname = usePathname();

  const hasPageDrawer = useMemo(() => {
    // Helper function to check if a pathname matches a route pattern with dynamic parameters
    const matchesRoutePattern = (pathname: string, pattern: string) => {
      // Convert route pattern to regex
      // Replace [param] with a regex pattern that matches any segment
      const regexPattern = pattern
        .replace(/\[([^\]]+)\]/g, '[^/]+') // Replace [param] with [^/]+ (match any non-slash character)
        .replace(/\//g, '\\/') // Escape forward slashes
        .replace(/\$/g, '\\$'); // Escape dollar signs if any

      const regex = new RegExp(`^${regexPattern}$`);
      return regex.test(pathname);
    };

    // Check if current pathname matches any of the routesWithoutDrawer patterns
    const shouldHideDrawer = routesWithoutDrawer.some(
      (route) =>
        // Check for exact match or pattern match
        pathname === route || matchesRoutePattern(pathname, route)
    );

    return !shouldHideDrawer;
  }, [pathname]);

  return { hasPageDrawer };
};

export default usePageDrawer;
